export default () => {
  if (window.gtag !== undefined) {
    //vérifier si la fonction existe
    (function ($) {
      $("#submitinfolettre").click(function (e) {
        //si le formulaire de l'infolettre à été envoyé
        gtag("event", "Infolettre Submited", {
          event_category: "Infolettre",
        });
      });

      //Rendre dynamique
      document.addEventListener(
        "wpcf7mailsent",
        function (event) {
          gtag("event", "Form sended", {
            //le nom de l'event
            event_category: "Formulaire", //la category de l'event
            event_label: event.detail.apiResponse.form_title,
          });
        },
        false
      );

      /**** Track all Mailto: & Tel:****/
      $("body").on(
        "click",
        "[href*='tel:'], [href*='mailto:'], a[data-direction]",
        function (e) {
          if (!$(this).data("tracking")) {
            $(this).attr("data-tracking", "1");

            e.preventDefault();
            var href = $(this).attr("href");

            // tel:
            if (href.toLowerCase().indexOf("tel:") >= 0) {
              eventCategory = "Call";
              eventLabel = href.replace("tel:", "");
            }

            // mailto:
            if (href.toLowerCase().indexOf("mailto:") >= 0) {
              eventCategory = "Email";
              eventLabel = href.replace("mailto:", "");
            }

            // click sur adresse:
            if ($(this).data("direction")) {
              eventCategory = "Direction";
              eventLabel = $(this).data("direction");
            }

            gtag("event", "Click", {
              event_category: eventCategory,
              event_label: eventLabel,
            });

            this.click();
          }
        }
      );
    })(jQuery);
  }
};
